import React from 'react';
import './EditProduct.css';
import AuthenticatedPage from 'gui/components/authenticatedPage/AuthenticatedPage';
import {IProduct} from 'data/interfaces/products';
import {
  hotelDetails,
  identifyProductCategoryType,
  ticketDetails,
  vacationDetails,
  voucherDetails
} from 'data/redux/constants/productsConstants';
import FlightEditor from 'gui/components/editors/flightEditor';
import HotelEditor from 'gui/components/editors/hotelEditor';
import VacationEditor from 'gui/components/editors/vacationEditor';
import VoucherEditor from 'gui/components/editors/voucherEditor';


const selectProductType = (props: IEditProductProps) => {
  switch (identifyProductCategoryType(props.product)) {
    case ticketDetails:
      return (<FlightEditor {...props} />);
    case hotelDetails:
      return (<HotelEditor {...props} />);
    case vacationDetails:
      return (<VacationEditor {...props} />);
    case voucherDetails:
      return (<VoucherEditor {...props}
                             productFieldHide={{voucherDetails: {type: true}}}
                             productSubType={props.product.voucherDetails.type}

      />);
  }
  return (<div/>);
}

interface IEditProductProps {
  onSubmit: (product: IProduct) => Promise<any>;
  navigateOnLogout?: () => void;
  product?: IProduct;
  id?: number;
  loadProductPage?: (id: number) => Promise<IProduct>;
  loadInitialFiles?: (id: number) => Promise<IProduct>;
  loading?: boolean;
}

class EditProduct extends AuthenticatedPage<IEditProductProps> {
  componentDidMount() {
    super.componentDidMount();
    if (this.props.product.id !== this.props.id) {
      this.props.loadProductPage(this.props.id);
    }
  }

  render() {
    return selectProductType(this.props);
  }
}


export default EditProduct;
